import { IKey } from '@/common/constants/ikey'
import { coerceTreeTableBoolean } from '@/common/utils/treeTableBoolean'
import { getFieldValueFromRow } from '@/common/utils/treeTableRowKeys'

function readDropFlag(row: unknown): boolean | null {
  if (!row || typeof row !== 'object') return null
  const rec = row as Record<string, unknown>
  const nested = rec.data && typeof rec.data === 'object' ? rec.data : null
  const raw =
    getFieldValueFromRow(row, IKey.TT_IS_DROP_TARGET) ??
    rec[IKey.TT_IS_DROP_TARGET] ??
    (nested ? getFieldValueFromRow(nested, IKey.TT_IS_DROP_TARGET) : undefined) ??
    (nested ? (nested as Record<string, unknown>)[IKey.TT_IS_DROP_TARGET] : undefined)
  return coerceTreeTableBoolean(raw)
}

/** MDD: колонка _isDropTarget перекрывает default (isAllowChildren). */
export function isTreeTableDropTarget(dest: {
  isAllowChildren?: unknown
  data?: unknown
} | null | undefined): boolean {
  if (!dest) return false
  const explicit = readDropFlag(dest) ?? readDropFlag(dest.data)
  if (explicit != null) return explicit
  const allow =
    coerceTreeTableBoolean(dest.isAllowChildren) ??
    coerceTreeTableBoolean(
      dest.data && typeof dest.data === 'object'
        ? (dest.data as Record<string, unknown>).isAllowChildren
        : undefined,
    )
  return allow === true
}
